import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RevisionProvider } from '../../revision-system/context/RevisionContext';
import { greekConfig } from '../config/greek-config';
import Dashboard from '../../revision-system/components/Dashboard';
import SectionManager from '../../revision-system/components/SectionManager';
import RevisionSession from '../../revision-system/components/RevisionSession';
import MigrationTool from '../../revision-system/components/MigrationTool';
import './App.css';

/**
 * Root component for the Greek Revision System
 * Manages routing and provides global state through context
 * 
 * Wiring:
 * - Dashboard: Connected to FirestoreService for loading due cards and statistics
 * - SectionManager: Connected to FirestoreService for section and card CRUD operations
 * - RevisionSession: Connected to SpacedRepetitionService and FirestoreService for reviews
 * - MigrationTool: Connected to FirestoreService for legacy data migration
 * 
 * Requirements: 6.1, 6.2
 */
const App: React.FC = () => {
  return (
    <RevisionProvider config={greekConfig}>
      <div className="greek-revision-app">
        <Routes>
          {/* Dashboard - main landing page */}
          <Route path="/" element={<Dashboard />} />
          
          {/* Section Manager - manage sections and cards */}
          <Route path="/sections" element={<SectionManager />} />
          <Route path="/sections/:sectionId" element={<SectionManager />} />
          
          {/* Revision Session - study cards */}
          <Route path="/session" element={<RevisionSession />} />
          <Route path="/session/:sectionId" element={<RevisionSession />} />
          
          {/* Migration Tool - migrate legacy cards */}
          <Route path="/migration" element={<MigrationTool config={greekConfig} />} />
          
          {/* Redirect unknown routes to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </RevisionProvider>
  );
};

export default App;
